import { ChangeEvent } from "react";
import { sortNamesBy } from "logic/sortNames";
import { VoiceFile, FloorMarking, VoiceSetId } from 'shared/models';
import { LegacySelectField } from "ui/shared/controls";
import { PlayAudioButton } from "ui/shared/controls/playAudioButton/PlayAudioButton";
import { useTranslation } from "react-i18next";
import { s3Bucket } from 'util/env';

require('./VoiceOverrideRow.css');

export type Props = {
    voiceSetId: VoiceSetId;
    floorMarking: FloorMarking;
    filename: string | null;
    voiceFiles: VoiceFile[];
    readOnly?: boolean;
    deleteOnValue: string;
    onChange(e: ChangeEvent<HTMLSelectElement>): void;
};

export const VoiceOverrideRow = ({ voiceSetId, floorMarking, filename, voiceFiles, readOnly = false, deleteOnValue, onChange }: Props) => {
    const { t } = useTranslation();
    
    const [ defaultVoiceFile, ...alternateVoiceFiles ] = voiceFiles;
    const options = alternateVoiceFiles.sort(sortNamesBy(vf => vf.filename));
    
    // The override does not apply if there is no such filename in the set of alternates
    const effectiveFilename =
        alternateVoiceFiles.some(vf => vf.filename === filename)
            ? filename
            : defaultVoiceFile.filename;

    const isDefault = !filename;

    return (
        <div
            className="voice-override-row"
            tabIndex={ 0 }
        >
            <div className="_floor-marking">
                { floorMarking }
            </div>
            <PlayAudioButton
                filename={ `https://${s3Bucket}.s3.amazonaws.com/voice-sets/${voiceSetId}/${effectiveFilename}` }
                className="_play-button"
            />
            <LegacySelectField
                id={ `device-config-voice-set-id-${floorMarking}` }
                className={ `_filename ${isDefault ? '_default' : ''}` }
                readOnly={ readOnly }
                input={ {
                    name: `properties.voiceOverrides.${floorMarking}`,
                    value: effectiveFilename || deleteOnValue,
                    onChange,
                } }
            >
                <option value={ deleteOnValue }>
                    { t('VOICE_SET.X_DEFAULT', [ defaultVoiceFile.filename ]) }
                </option>
                { options.map(voiceFile =>
                    <option
                        key={ voiceFile.filename }
                        value={ voiceFile.filename }
                    >
                        { voiceFile.filename }
                    </option>
                ) }
            </LegacySelectField>
        </div>
    );
};
